export const SET_LOADING = "setLoading";
export const SET_MOBILE = "setMobile";
export const SHOW_TOAST = "showToast";
export const HIDE_TOAST = "hideToast";
export const SET_MODAL_PERMISSION = "setModalPermission";
